import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error) => {
                // Не повторяем запросы при ошибках сети (ERR_CONNECTION_REFUSED)
                if (error?.message?.includes('Failed to fetch') || 
                    error?.message?.includes('ERR_CONNECTION_REFUSED')) {
                    return false;
                }
                // Повторяем только 1 раз для других ошибок
                return failureCount < 1;
            },
            retryDelay: 1000,
            staleTime: 5 * 60 * 1000, // 5 минут
            cacheTime: 10 * 60 * 1000, // 10 минут
        },
        mutations: {
            retry: false,
        },
    },
});
